import type { EditItemPurchaseOrderObservationsRequestProps } from '@services/api/ocNf/types'
import type { PurchaseOrderDetailsFormProps } from '../components/PurchaseOrderDetails/form/types'

export const parseItemPurchaseOrderObservationPayload = (formData: PurchaseOrderDetailsFormProps | null) => {
  const payload: EditItemPurchaseOrderObservationsRequestProps = {
    routeParams: {
      filiCode: formData?.filiCode || '',
      competenceDate: formData?.competenceDate || ''
    },
    bodyParams: {
      supplierCode: formData?.supplierCode ? Number(formData?.supplierCode) : '',
      purchaseOrderNumber: formData?.purchaseOrderNumber ? Number(formData?.purchaseOrderNumber) : '',
      observation: formData?.observations || ''
    }
  }

  return payload
}
